'use client';

// CHÂSSIS DU TÉLÉPHONE — dessiné en CSS (aucune image), thème-aware, net à toute taille.
//
// Deux points appris à l'usage, à ne pas défaire :
//   · l'écran est `relative` ET `overflow-hidden` : la barre d'onglets doit se positionner DANS
//     lui, sinon elle se cale sur le châssis et déborde par-dessus les coins arrondis ;
//   · aucun agrandissement (`scale > 1`) ne doit lui être appliqué — un élément transformé étire
//     sa texture rasterisée et devient flou. Il est donc dessiné à sa taille définitive.

export function PhoneFrame({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative w-[248px] rounded-[2.6rem] border-[11px] border-[color:var(--rmbr-text-primary)] bg-background shadow-[var(--rmbr-shadow-xl)] sm:w-[286px] lg:w-[310px]">
      {/* Encoche */}
      <div
        aria-hidden
        className="absolute left-1/2 top-2 z-20 h-[19px] w-[74px] -translate-x-1/2 rounded-full bg-[color:var(--rmbr-text-primary)]"
      />

      {/* Écran : tout le contenu vit ici, et rien n'en sort. */}
      <div className="relative h-[540px] overflow-hidden rounded-[1.8rem] bg-background sm:h-[600px] lg:h-[640px]">
        {children}

        {/* Barre d'onglets — on est bien dans une application, pas dans une maquette. */}
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-around border-t border-border bg-surface/85 px-4 py-3 backdrop-blur">
          {[0, 1, 2, 3].map((i) => (
            <span
              key={i}
              className={`size-1.5 rounded-full ${i === 0 ? 'bg-brand' : 'bg-border'}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
